import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';
import urlLogo from '../Compartido/urlLogo.js';

const DatosExperiencia = ({ experiencia, ruta, config }) => {

    const { t } = useTranslation();

    const imagen = experiencia.imagen ? ruta + "/experiencias/" + experiencia.id + "/" + experiencia.imagen : null;

    return (
        <PaginaTexto
            titulo={experiencia.elnombre}
            eyebrow={t("Experiencias")}
            imagen={imagen}
            logo={urlLogo(config, ruta)}
            html={experiencia.eltexto}
        />
    );
}

export default DatosExperiencia;
